import React from "react";

import dayjs from "dayjs";

import { ColumnStyle } from "components/Common/TableStyle";

export const SAMPLE_INIT = {
  referenceSourceName: "",
  referenceSourceDescription: "",
  referenceType: "",
  scope: "",
  drafter: "",
  approver: "",
};

export const COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Value",

    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Value Description",

    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "start_date",
    key: "start_date",
    title: "Start Date",

    render: text => <ColumnStyle text={dayjs(text).format("YYYY-MM-DD")} />,
  },
  {
    dataIndex: "end_date",
    key: "end_date",
    title: "End Date",

    render: text => <ColumnStyle text={dayjs(text).format("YYYY-MM-DD")} />,
  },
];
